<div [innerHTML]="plainHintMsg" class="plain-hint"></div>
